import { getCookie, setCookie, removeCookie } from 'tiny-cookie';

const decodeJson = json => (json ? JSON.parse(decodeURIComponent(json)) : null);
const encodeJson = json => encodeURIComponent(JSON.stringify(json));

export const setCookieJSON = (key, value, options) =>
  setCookie(key, value, encodeJson, options);

export const getCookieJSON = key => getCookie(key, decodeJson);

export const removeCookieJSON = key => removeCookie(key);
